/**
 * Interfaz que define los atributos que tendra el store del metadata
 * * Precio de los UFs (tanto para barrios como para edificios)
 * * Minimo de UFs permitidas en la plataforma
 * * Valor del IVA
 * * Mapeo de estados de los acuerdos comerciales (contiene el siguiente estado por el que puede pasar un acuerdo en base al estado actual del mismo)
 * * Lista de usuarios de sales
 */
export interface CAMetadataState {
  precio_ufs: {
    precio_barrio: number,
    precio_edificio: number
  };
  minimo_ufs_plataforma: number;
  iva: number;
  mapeo_estados: { [estado_actual: string]: string };
  usuarios_sales: string[];
}

// Mutations de la metadata
export const METADATA_MUTATION_PRECIO_UFS: string = 'agregarPrecioUFS';
export const METADATA_MUTATION_MINIMO_UFS_PLATAFORMA: string = 'agregarMinimoUFSPlataforma';
export const METADATA_MUTATION_IVA: string = 'agregarIVA';
export const METADATA_MUTATION_MAPEO_ESTADOS: string = 'agregarMapeoEstados';
export const METADATA_MUTATION_USUARIOS_SALES: string = 'agregarUsuariosSales';

// Getters de la metadata
export const METADATA_GETTER_PRECIO_UFS: string = 'obtenerPrecioUFS';
export const METADATA_GETTER_MINIMO_UFS_PLATAFORMA: string = 'obtenerMinimoUFSPlataforma';
export const METADATA_GETTER_IVA: string = 'obtenerIVA';
export const METADATA_GETTER_MAPEO_ESTADOS: string = 'obtenerMapeoEstados';
export const METADATA_GETTER_USUARIOS_SALES: string = 'obtenerUsuariosSales';
